// Local rep search form functionality

// Initializes the local rep search form
function initialize() {

  const regionSelector  = '#local-rep-region';
  const addressWrapperSelector = '.wf-local-rep-address-wrapper';
  const countryWrapperSelector = '.wf-local-rep-country-wrapper';
  const stateWrapperSelector = '.wf-local-rep-state-wrapper';
  
  const region = document.querySelector(regionSelector);
  const addressWrapper = document.querySelector(addressWrapperSelector);
  const countryWrapper = document.querySelector(countryWrapperSelector);
  const stateWrapper = document.querySelector(stateWrapperSelector);

  if (region) {
    region.addEventListener('change', event => {
      updateSelectedRegion();
    });

    updateSelectedRegion();
  }

  function updateSelectedRegion() {
    const selectedRegion = region.options[region.selectedIndex];
    const selectedRegionFilterWrapper = document.querySelector('*[data-wf-for-region="' + selectedRegion.value + '"]');
    const regionOptionsValue = selectedRegion.dataset['wfLocalRepRegionOptions'];
    const addressInput = addressWrapper.querySelector('input');
    const countrySelect = countryWrapper.querySelector('select');
    const stateSelect = stateWrapper.querySelector('select');

    // Hide the conditional input wrappers and reset their values
    addressWrapper.setAttribute('style', 'display: none;');
    countryWrapper.setAttribute('style', 'display: none;');
    stateWrapper.setAttribute('style', 'display: none;');
    addressInput.value = '';
    countrySelect.innerHTML = '';
    stateSelect.innerHTML = '';

    if (regionOptionsValue) {
      // Options exist for this region - populate the country dropdown and show it
      const selectedRegionFilter = selectedRegionFilterWrapper.querySelector('select');
      const regionOptions = regionOptionsValue.split(',');
      
      regionOptions.forEach(regionOption => {
        const regionOptionValue = regionOption.split('|')[0];
        const regionOptionText = regionOption.split('|')[1];
        const regionOptionElement = new Option(regionOptionText, regionOptionValue);

        selectedRegionFilter.add(regionOptionElement);
        selectedRegionFilterWrapper.setAttribute('style', '');
      });
    } else {
      // Options don't exist for this region - show the textbox instead
      addressWrapper.setAttribute('style', '');
    }
  }
}

initialize();